import { connect, MapStateToProps } from 'react-redux';
import { getCurrentUserHasCore } from '@wix/da-shared-react/pkg/publicSession/selectors';
import { Props } from './BillingCyclePicker';
import {
  getCurrentCoreSubscription,
  getSale,
} from '../../../../../redux/packagePicker/selectors';

export type StateProps = Pick<
  Props,
  'alreadyHasSubscription' | 'hasPrepaidSubscription' | 'sale'
>;
export type DispatchProps = Pick<Props, never>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, any> = (
  state,
  ownProps
) => ({
  alreadyHasSubscription: ownProps.giftUser
    ? false
    : getCurrentUserHasCore(state),
  hasPrepaidSubscription: ownProps.giftUser
    ? false
    : getCurrentCoreSubscription(state)?.isUpgradable
    ? true
    : false,
  sale: getSale(state),
});

export default connect(mapStateToProps);
